export default __webpack_public_path__ + "static/media/pg-15.1a2b263f.jpg";